import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return 'N/A';
  
  // Handle various date formats
  let date;
  if (typeof dateString === 'string') {
    // If string doesn't have timezone info, assume UTC
    if (!dateString.includes('Z') && !dateString.includes('+') && !dateString.includes('-', 10)) {
      dateString = dateString + 'Z';  // Append Z to indicate UTC
    }
    date = new Date(dateString);
  } else if (dateString instanceof Date) {
    date = dateString;
  } else {
    date = new Date(dateString);
  }
  
  // Check for invalid date
  if (isNaN(date.getTime())) return 'N/A';
  
  // Convert to IST (Asia/Kolkata timezone)
  return date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatNumber(num) {
  if (num === null || num === undefined) return '0';
  return new Intl.NumberFormat('en-US').format(num);
}

export function downloadFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

/**
 * Safe API error message extractor.
 * Handles FastAPI/Pydantic structured validation errors:
 *   detail = [{type, loc, msg, input}, ...]
 * and plain string errors:
 *   detail = "Some error message"
 * Returns a safe string suitable for rendering in JSX.
 */
export function formatApiError(error, fallback = 'An unexpected error occurred') {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;

  // Plain string
  if (typeof detail === 'string') return detail;

  // Pydantic validation array: [{type, loc, msg, input}, ...]
  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object' && item.msg) {
          const field = Array.isArray(item.loc)
            ? item.loc.filter((l) => l !== 'body').join('.')
            : '';
          return field ? `${field}: ${item.msg}` : item.msg;
        }
        return String(item);
      })
      .filter(Boolean);
    return messages.length > 0 ? messages.join('; ') : fallback;
  }

  // Object with message property (business errors use .message, Pydantic uses .msg)
  if (typeof detail === 'object' && detail.message) return detail.message;
  if (typeof detail === 'object' && detail.msg) return detail.msg;

  // Unknown shape — stringify safely
  try {
    return JSON.stringify(detail);
  } catch {
    return fallback;
  }
}